"use client";

import { PRODUCTION } from "@/app/utilities/constants";
import Script from "next/script";
import { useEventTrigger } from "@/utils/hooks/useEventTrigger";
import useAfterLCP from "@/utils/hooks/useAfterLCP";

export const HeadScripts = () => {
    const isGptTriggered = useEventTrigger({ trigger: "scroll", scrollThreshold: 40 });
    // Same as bj_nextjs_frontend: keep gtag/GTM off the LCP critical path.
    const shouldLoadDeferred = useAfterLCP();

    if (process.env.NEXT_PUBLIC_ENV !==PRODUCTION) {
        return null;
    }
    return (
        <>
             {/* Sync-load Next-equivalent polyfills only when APIs are missing.
            Modern browsers skip the file → clears Lighthouse Legacy JS. */}
            <script
                dangerouslySetInnerHTML={{
                    __html: `(function(){if(Array.prototype.at&&Object.hasOwn&&Object.fromEntries&&Array.prototype.flat&&String.prototype.trimStart&&Promise.prototype.finally&&"description"in Symbol.prototype&&"canParse"in URL)return;document.write('<script src="/js/legacy-polyfills.js"><\\/script>')})();`,
                }}
            />
            {/* dataLayer exists early so pushes before GTM loads are queued, not lost. */}
            <script
                id="gtm-datalayer-init"
                dangerouslySetInnerHTML={{
                    __html: "window.dataLayer=window.dataLayer||[];",
                }}
            />
            {shouldLoadDeferred && (
            <>
            {/* ── Google tag (gtag.js) — loaded once, configured for both GA4 and Google Ads. ── */}
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_ID}`}
                strategy="afterInteractive"
            />
            <Script id="gtag-init" strategy="afterInteractive">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${process.env.NEXT_PUBLIC_GA_ID}', {
                        page_path: window.location.pathname,
                    });
                    gtag('config', '${process.env.NEXT_PUBLIC_GTM_MARKETING_ADS_ID}');
                `}
            </Script>

            {/* ── GTM (snippet only — do NOT also load gtm.js directly, the snippet does it). ── */}
            <Script id="gtm-inline" strategy="afterInteractive">
                {`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');
                `}
            </Script>
            </>
            )}

            {/* ── GPT (Google Publisher Tag) — on mobile, deferred until the user scrolls 40px+ ── */}
            {isGptTriggered && (
                <Script
                    src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    strategy="lazyOnload"
                />
            )}
        </>
    );
};